import React, { useState } from 'react'
import { OpenModalButtonProps } from 'types/common'

const OpenModalButton: React.FC<OpenModalButtonProps> = ({
  button,
  label,
  children,
  selectedIds = [],
  ...props
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const openModal = () => {
    setOpen(true)
  }
  const closeModal = () => setOpen(false)

  return (
    <React.Fragment>
      {React.cloneElement(button, { onClick: openModal, label })}
      {children({
        closeModal,
        isOpen: open,
        title: label,
        selectedIds,
        ...props,
      })}
    </React.Fragment>
  )
}

export default OpenModalButton
